// Code generated by master-scheme ServiceTypesGenerator - DO NOT EDIT
// Generator: /Users/victorvins/Projects/master-scheme/dsl/src/ts-api/ServiceTypesGenerator.scala

import { postEndpoint } from '@innolab-trader/tradovate-transport'
import type { ValidationError } from '@innolab-trader/tradovate-types'
import type { RejectedReason } from '@innolab-trader/tradovate-types/src/enums/rejectedReason'

export interface CancelOrder {
  orderId: number
  clOrdId?: string
  activationTime?: string
  customTag50?: string
  isAutomated?: boolean
}

export interface CommandResult {
  failureReason?: RejectedReason
  failureText?: string
  commandId?: number
}

/**
 * Validate CancelOrder request
 *
 * Follows Rust validation pattern with structured errors
 *
 * @param request - The request object to validate
 * @returns Array of validation errors, empty if valid
 *
 * @example
 * ```typescript
 * const errors = validateCancelOrder(requestData)
 * if (errors.length > 0) {
 *   return { status: 400, errors }
 * }
 * ```
 */
export function validateCancelOrder(request: CancelOrder): ValidationError[] {
  const errors: ValidationError[] = []

  const req = request as unknown as Record<string, unknown>
  if (req.orderId === undefined || req.orderId === null) {
    errors.push({
      field: 'orderId',
      code: 'required',
      message: 'orderId is required'
    })
  }

  if (typeof req.clOrdId === 'string' && req.clOrdId.length > 64) {
    errors.push({
      field: 'clOrdId',
      code: 'too_long',
      message: 'clOrdId must not exceed 64 characters',
      argument: '64'
    })
  }

  if (typeof req.customTag50 === 'string' && req.customTag50.length > 64) {
    errors.push({
      field: 'customTag50',
      code: 'too_long',
      message: 'customTag50 must not exceed 64 characters',
      argument: '64'
    })
  }

  return errors
}

export const cancelOrder = postEndpoint<CancelOrder, CommandResult>('/order/cancelOrder')
